import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "../../actions/EmailAuthenticationActions";
import UrlHelper from "../../utilities/UrlHelper";

export class LinkExpiredPage extends Component {
    constructor (props) {
        super(props);
    }

    componentDidMount() {
        import("./_styles.scss");
        const isVirtualUser = this.isVirtualUser();
        const ticketType = UrlHelper.getParameterByName("ticketType");

        this.props.getTicketExpirationPeriod(isVirtualUser, ticketType);
    }

    isVirtualUser () {
        const isVirtualUser = UrlHelper.getParameterByName("isVirtualUser");
        return isVirtualUser && isVirtualUser.toLowerCase() === "true";
    }

    render () {
        const expirationPeriod = this.props.expirationPeriod;
        const title = "Link Expired";
        return (
            <div className="linkExpired">
                <div className="form-title"><span className="label-blue-alarm-icon"/><span className="title">{title}</span></div>

                <div className="form-subtitle">
                    <p>
                        For security reasons, the link you clicked was only valid for {expirationPeriod},
                        and has expired.
                    </p>
                    <p>
                        <b>To get a new link</b> to verify your account or reset your password:
                    </p>
                    <ul>
                        <li><a href={this.isVirtualUser() ? "./EmailLogin" : "./Login"}>Go back to the sign-in screen</a></li>
                        <li>Enter your email and click Next</li>
                        <li>To verify your account, click <b>Send Verification Email</b></li>
                        <li>To reset your password, click the <b>Reset Password</b> link</li>
                    </ul>
                    <p>
                        If you need further assistance, contact
                        your administrator or Wolters Kluwer support at <a href="tel:(800)341-0450">(800)341-0450</a> or
                        <a href="mailto:CSCSupport@wolterskluwer.com"> CSCSupport@wolterskluwer.com</a>.
                    </p>
                </div>
            </div>
        );
    }
}

LinkExpiredPage.defaultProps = {
    getTicketExpirationPeriod: () => {},
    expirationPeriod: ""
};

LinkExpiredPage.propTypes = {
    getTicketExpirationPeriod: PropTypes.func,
    expirationPeriod: PropTypes.string
};

const mapStateToProps = state => ({
    expirationPeriod: state.linkExpiredState.expirationPeriod
});

const mapDispatchToProps = (dispatch) => {
    return ({
        getTicketExpirationPeriod: (isVirtualUser, ticketType) => dispatch(actions.getTicketExpirationPeriod(isVirtualUser, ticketType))
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkExpiredPage);
